<template>
  <div class="sidebar left advanced-search" :class="{'hidden': settings.filter === false}">
    <div class="fixed-container">

      <div class="sidebar-content-view">
        <!-- Top bar -->
        <div class="grid-x toolbar header">
          <div class="search-toolbar-header">
            <div class="advanced-search-header">
              <TheSwitchInputRaw v-model="settings.filter" :small="true" :align="'right'" labelTrue="Søkefilter:" labelFalse="Søkefilter:" :trueValue="true" :falseValue="false"/>

              <span class="search-results-numbers" v-if="!result.objekt.searching && (params.query || result.objekt.items.length > 0)">
                <strong>{{result.objekt.total}}</strong> treff<span v-if="params.query"> på <strong>«{{params.query}}»</strong></span>
              </span>
              <span class="search-results-numbers" v-if="result.objekt.searching">
                Søker
                <span v-if="params.query">på <strong>«{{params.query}}»</strong></span>
                <span v-else>...</span>
              </span>

              <div class="radio-button-container tiny" id="topbar-search-thumbnails">
                <span class="title">Bilder:</span>
                <ul>
                  <li><input type="radio" v-model="settings.listtype" value="small" name="search-thumbnails" id="search-thumbnails-small" :checked="!settings.listtype || settings.listtype === 'small'"> <label for="search-thumbnails-small">Små</label></li>
                  <li><input type="radio" v-model="settings.listtype" value="large" name="search-thumbnails" id="search-thumbnails-large" :checked="settings.listtype === 'large'"> <label for="search-thumbnails-large">Store</label></li>
                  <li><input type="radio" v-model="settings.listtype" value="none" name="search-thumbnails" id="search-thumbnails-none" :checked="settings.listtype === 'none'"> <label for="search-thumbnails-none">Ingen</label></li>
                </ul>
                <span class="button-container" style="margin-left: 0.75rem; margin-right: 0.25rem;">
                  <a v-if="result.objekt.searching" class="button action glyph glyph-only small disabled">
                    <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-print"></use></svg>
                    <span>Export</span>
                  </a>
                  <a v-else class="button action glyph glyph-only small" :class="{'loading': exporting}" @click="exportAsExcel()">
                    <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-print"></use></svg>
                    <span class="loader-spinner"></span>
                    <span>Export</span>
                  </a>
                </span>

                <!-- Begin: The new popover with settings for columns -->
                <span class="button-container has-popover" :class="{'popover-active': settingsPopoverActive}">
                  <span class="button action glyph glyph-only small" @click="toggleSettingsPopover">
                    <svg width="12px" height="12px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-edit"></use></svg>
                    <span>Innstillinger</span>
                  </span>

                  <span class="popover popover-has-footer popover-has-header sortable align-x-right align-y-bottom large">
                    <div class="popover-header">
                      <span class="title">Organiser kolonner</span>
                    </div>
                    <div class="custom-scrollbar" id="columnsorter">
                      <draggable tag="ul" handle=".handle" :value="selectedCols" :move="onDragMove" @change="onDragChange">
                        <li v-for="(column, index) in selectedCols" v-bind:key="index" :class="{'disabled': !selectedCols[index].value, 'inactive': !selectedCols[index].value}">
                          <TheSwitchInputPopoverDragable v-if="column.name === 'Tekst_ok'" v-model="selectedCols[index].value" :label="'Objekt'" labelTrue="" labelFalse="" :trueValue="true" :falseValue="false"/>
                          <TheSwitchInputPopoverDragable v-else-if="column.name === 'Fototatt'" v-model="selectedCols[index].value" :label="'Foto'" labelTrue="" labelFalse="" :trueValue="true" :falseValue="false"/>
                          <TheSwitchInputPopoverDragable v-else-if="column.name === 'Bet_dato'" v-model="selectedCols[index].value" :label="'Betalt'" labelTrue="" labelFalse="" :trueValue="true" :falseValue="false"/>
                          <TheSwitchInputPopoverDragable v-else-if="column.name === 'Lev_dato'" v-model="selectedCols[index].value" :label="'Utlevert'" labelTrue="" labelFalse="" :trueValue="true" :falseValue="false"/>
                          <TheSwitchInputPopoverDragable v-else-if="column.name === 'oppgjor_dato'" v-model="selectedCols[index].value" :label="'Oppgjørsdato'" labelTrue="" labelFalse="" :trueValue="true" :falseValue="false"/>
                          <TheSwitchInputPopoverDragable v-else-if="column.name === 'oppgjor_belop'" v-model="selectedCols[index].value" :label="'Oppgjørsbelop'" labelTrue="" labelFalse="" :trueValue="true" :falseValue="false"/>
                          <TheSwitchInputPopoverDragable v-else v-model="selectedCols[index].value" :label="column.name" labelTrue="" labelFalse="" :trueValue="true" :falseValue="false"/>
                        </li>
                      </draggable>
                    </div>
                    <div class="popover-footer">
                      <span class="button primary transparent tiny" @click="resetColumns()">Tillbakestill</span>
                      <span class="button primary tiny" @click="saveColumns()">Lagre</span>
                    </div>
                  </span>
                </span>
              </div>
            </div>
            <a href="javascript:;" @click="closeSearch()" class="modal-window-close-button modal-window-sidebar-close-button"><span>Lukk</span> <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-close"></use></svg></a>
          </div>
        </div>
        <!-- End top bar -->

        <!-- Form -->
        <overlay-scrollbars :options="{ className: 'sidebar-content-container small-padding custom-scrollbar os-theme-dark', scrollbars: { visibility: 'auto', autoHide: 'leave', autoHideDelay: 400, dragScrolling: true, clickScrolling: false, touchSupport: true, snapHandle: false } }">
          <div class="small-form-grid">
            <div class="grid-x grid-padding-x">
              <TheAutoCompleteInput v-model.trim="params.Kunstnername" containerClassName="cell medium-12" :placeholder="'Velg kunstner…'" :label="'Kunstner'" :onInputCallback="onKunstnerSearchInput" :onSelectCallback="onKunstnerSearchSelected" :onResetCallback="onKunstnerReset" :debounce="750" :minquery="2">
                <div slot="item" slot-scope="props">
                  {{props.item.Navn}}
                </div>
              </TheAutoCompleteInput>

              <TheAutoCompleteInput v-model.trim="params.Auksjon" containerClassName="cell medium-12" :placeholder="'Velg auksjon…'" :label="'Auksjon'" :onInputCallback="onAuksjonSearchInput" :onSelectCallback="onAuksjonSearchSelected" :onResetCallback="onAuksjonReset" :debounce="750" :minquery="2">
                <div slot="item" slot-scope="props">
                  <strong>{{props.item.Auksjon}}</strong>, {{props.item.Beskrivelse}}
                  <span v-if="props.item.Auksjon_dato">
                    ({{ props.item.Auksjon_dato | avantidate }})
                  </span>
                </div>
              </TheAutoCompleteInput>

              <div class="cell">
                <div class="input-container checkbox">
                  <input type="checkbox" name="auksjon-search-all" id="auksjon-search-all" v-model="params.AuksjonSearchAll"/>
                  <label for="auksjon-search-all">Søk også i den forrige auksjonen.</label>
                  <span class="glyph"><svg viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#glyph-input-checkbox"></use></svg></span>
                </div>
              </div>

              <div class="cell">
                <label for="price_from">Vurdering fra</label>
                <div class="input-container currency symbol-glyph" data-symbol="kr">
                  <input type="text" v-model="params.price_from" id="price_from">
                </div>
              </div>

              <div class="cell">
                <label for="price_to">Vurdering til</label>
                <div class="input-container currency symbol-glyph" data-symbol="kr">
                  <input type="text" v-model="params.price_to" id="price_to">
                </div>
              </div>
            </div>
          </div>

          <div class="small-form-grid">
            <div class="grid-x grid-padding-x">
              <TheSelectInput v-model="params.Avdelingsid" containerClassName="cell" label="Avdeling" name="Avdelingsid" :items="avdDropdown" :disabled="loaded !== 3"/>
              <TheSelectInput v-model="params.Kategori" containerClassName="cell" label="Kategori" name="Kategori" :items="catDropdown" :disabled="loaded !== 3"/>
              <TheSelectInput v-model="params.Objekttype" containerClassName="cell" label="Kontraktstype" name="Objekttype" :items="typeDropdown" :disabled="loaded !== 3"/>

              <div class="cell">
                <label for="date_from">Registrert dato fra</label>
                <div class="input-container date dropdown-top">
                  <b-datepicker
                    :show-week-number="false"
                    :editable="false"
                    :first-day-of-week="1"
                    :max-date="params.date_to"
                    v-model="params.date_from"
                    placeholder="Vis kalender..."
                    icon="glyph-input-date"
                    ref="date_from"
                    id="date_from">
                    <button class="button disabled" v-if="!params.date_from" @click.prevent="$refs.date_from.toggle()"><span>Slett dato</span></button>
                    <button class="button" v-else @click.prevent="params.date_from = null"><span>Slett dato</span></button>
                  </b-datepicker>
                  <span class="glyph"><svg viewBox="0 0 44 44"><use xlink:href="/static/sprites.svg#glyph-input-date"></use></svg></span>
                </div>
              </div>

              <div class="cell">
                <label for="date_to">Registrert dato til</label>
                <div class="input-container date dropdown-top">
                  <b-datepicker
                    :show-week-number="false"
                    :editable="false"
                    :first-day-of-week="1"
                    :min-date="params.date_from"
                    v-model="params.date_to"
                    placeholder="Vis kalender..."
                    icon="calendar-today"
                    ref="date_to"
                    id="date_to">
                    <button class="button disabled" v-if="!params.date_to" @click.prevent="$refs.date_to.toggle()"><span>Slett dato</span></button>
                    <button class="button" v-else @click.prevent="params.date_to = null"><span>Slett dato</span></button>
                  </b-datepicker>
                  <span class="glyph"><svg viewBox="0 0 44 44"><use xlink:href="/static/sprites.svg#glyph-input-date"></use></svg></span>
                </div>
              </div>
            </div>
          </div>
        </overlay-scrollbars>

        <div class="grid-x toolbar footer large-padding">
          <div class="grid-x">
            <div class="cell auto">
              <a href="javascript:;" @click="resetForm" class="button primary large transparent">Tilbakestill</a>
            </div>
            <div class="cell shrink">
              <a v-if="!result.objekt.searching && loaded" href="javascript:;" @click="submitForm" class="button primary"><span class="button-title">Oppdater søk</span></a>
              <a v-if="!result.objekt.searching && !loaded" href="javascript:;" class="button primary disabled"><span class="button-title">Oppdater søk</span></a>
              <a v-if="result.objekt.searching" href="javascript:;" @click="submitForm" class="button primary loading"><span class="button-title">Oppdaterer søk</span> <span class="loader-spinner"></span></a>
            </div>
          </div>
        </div>
        <!-- End form -->
      </div>
    </div>
  </div>
</template>

<script>
import bus from '@/plugins/event-bus'
import TheAutoCompleteInput from '../Inputs/TheAutoCompleteInput'
import AuksjonService from '@/services/AuksjonService'
import KunstnerService from '@/services/KunstnerService'
import InstillingerService from '@/services/InstillingerService'
import SearchService from '@/services/SearchService'
import TheSwitchInputRaw from '../Inputs/TheSwitchInputRaw'
import draggable from 'vuedraggable'
import accounting from 'accounting-js'
import moment from 'moment'
import Papa from 'papaparse'
import fileDownload from 'js-file-download'

const swapArrayElements = function (array, index1, index2) {
  array[index1] = array.splice(index2, 1, array[index1])[0]
  return array
}

export default {
  name: 'TheMainSearchAdvancedForm',
  components: {
    TheAutoCompleteInput,
    TheSwitchInputRaw,
    draggable
  },
  data () {
    return {
      exporting: false,
      settingsPopoverActive: false,
      typeDropdown: [],
      avdDropdown: [],
      catList: [],
      loaded: 0,
      selectedCols: []
    }
  },
  props: {
    result: {
      type: Object,
      required: false,
      default () {
        return {}
      }
    },
    params: {
      type: Object,
      required: true
    },
    exportParams: {
      type: Object,
      required: true
    },
    settings: {
      type: Object,
      required: false,
      default () {
        return {}
      }
    },
    defaultColumns: {
      type: Array,
      required: false,
      default () {
        return []
      }
    }
  },
  created () {
    var vm = this

    this.selectedCols = this._.cloneDeep(this.settings.columns)

    // Remove popover on click outside...
    window.jQuery(document).mouseup(function (e) {
      var container = window.jQuery('.has-popover')
      // if the target of the click isn't the container nor a descendant of the container
      if (!container.is(e.target) && container.has(e.target).length === 0) {
        vm.settingsPopoverActive = false
      }
    })

    this.fetch()
  },

  computed: {
    userHeadings: function () {
      let retval = []

      this.settings.columns.forEach((item) => {
        if (item.value) {
          let found = this.headings.findIndex(x => x.name === item.name)

          if (found !== -1) {
            retval.push(this.headings[found])
          }
        }
      })

      return retval
    },
    catDropdown: function () {
      let retval = []
      let selected = this.params.Avdelingsid
      if (selected === '') {
        selected = null
      }

      if (selected === null) {
        retval = this.catList.filter((i) => {
          return true
        })
        retval.unshift({ key: null, val: 'Alle' })
        // retval.unshift({key: null, val: 'Velg avdeling først'})
      } else {
        selected = parseInt(selected)
        retval = this.catList.filter((i) => {
          return parseInt(i.avdelingsid) === selected
        })

        if (retval.length < 1) {
          retval.unshift({ key: null, val: 'Alle' })
        } else {
          retval.unshift({ key: null, val: 'Alle' })
        }
      }

      return retval
    }
  },
  watch: {
    'params.Avdelingsid': function (newVal) {
      this.params.Kategori = null
    }
  },
  methods: {
    exportAsExcel: function () {
      if (!this.exportParams || this.exporting) {
        return
      }

      this.exporting = true

      SearchService.objektExport(this.exportParams)
        .then((response) => {
          const fields = []
          const data = []

          // Get all headings in correct order...
          this.settings.columns.forEach((item) => {
            // Skip bilde and Relevans
            if (item.value && !(item.name === 'Bilde' || item.name === 'Relevans')) {
              if (item.name === 'oppgjor_dato') {
                fields.push('Oppgjørsdato')
              } else if (item.name === 'oppgjor_belop') {
                fields.push('Oppgjørsbelop')
              } else {
                fields.push(item.name)
              }
            }
          })

          // Push headings into data array
          data.push(fields)

          // Need to parse data of objects, so we get correct value for each key
          response.data.forEach((item) => {
            let temp = []

            fields.forEach((heading) => {
              switch (heading) {
                case 'Auksjonsdato':
                  temp.push(this.$options.filters.avantidate(item.auksjonsdato))
                  break
                case 'Kunstner':
                  temp.push(item.kunstner ? item.kunstner.Navn : '-')
                  break
                case 'Tittel':
                  temp.push(item.Katalogtekst1 || '')
                  break
                case 'Beskrivelse':
                  temp.push(item.Objekt3 || '-')
                  break
                case 'Tekst':
                  temp.push(item.Katalogtekst2 || '-')
                  break
                case 'Tilslag':
                  if (this._.startsWith(item.Auksjon, 'AR')) {
                    temp.push('Usolgt')
                  } else if (item.Salgspris > 0) {
                    temp.push(accounting.formatNumber(item.Salgspris, { precision: 0, thousand: ' ' }))
                  } else if (item.Salgspris === '0' || item.Salgspris === 0) {
                    temp.push('0')
                  } else {
                    temp.push('-')
                  }
                  break
                case 'Vurdering':
                  if (item.Vurderingspris1 > 0 && item.Vurderingspris2 > 0) {
                    temp.push(this.$options.filters.thousands(item.Vurderingspris2) + ' - ' + this.$options.filters.thousands(item.Vurderingspris1))
                  } else if (item.Vurderingspris1 > 0) {
                    temp.push(this.$options.filters.thousands(item.Vurderingspris1))
                  } else if (item.Vurderingspris2 > 0) {
                    temp.push(this.$options.filters.thousands(item.Vurderingspris2))
                  } else {
                    temp.push('-')
                  }
                  break
                case 'Minstepris':
                  temp.push(this.$options.filters.thousands(item.Minstepris))
                  break
                case 'Signert':
                  temp.push(item.Objekt1 || '-')
                  break
                case 'Lokasjon':
                  temp.push(item.lokasjon ? item.lokasjon.Lokasjonkode : '-')
                  break
                case 'Hentet':
                  temp.push(this.$options.filters.avantidate(item.Lev_dato))
                  break
                case 'Avdeling':
                  temp.push(item.avdeling ? item.avdeling.Beskrivelse : '-')
                  break
                case 'Type':
                  temp.push(item.Objekttype || '-')
                  break
                case 'Tekst_ok':
                  temp.push(item.Tekst_ok === 'T' ? 'Ja' : 'Nei')
                  break
                case 'Fototatt':
                  temp.push(item.Fototatt === 'T' ? 'Ja' : 'Nei')
                  break
                case 'Registrert dato':
                  temp.push(this.$options.filters.avantidate(item.Registrert_dato))
                  break
                case 'Bet_dato':
                  temp.push(this.$options.filters.avantidate(item.Bet_dato))
                  break
                case 'Lev_dato':
                  temp.push(this.$options.filters.avantidate(item.Lev_dato))
                  break
                case 'Fakturert':
                  temp.push(item.Fakturert === 'F' ? 'Ja' : 'Nei')
                  break
                case 'oppgjor_dato':
                case 'Oppgjørsdato':
                  temp.push(this.$options.filters.avantidate(item.oppgjor_dato))
                  break
                case 'oppgjor_belop':
                case 'Oppgjørsbelop':
                  temp.push(this.$options.filters.thousands(item.oppgjor_belop))
                  break
                case 'Katalognr':
                  temp.push(item.Katalognr || '-')
                  break
                case 'Kontraktansvarlig':
                  temp.push(item.kontraktsansvarlig ? item.kontraktsansvarlig.full_name : '-')
                  break
                default:
                  temp.push(item.hasOwnProperty(heading) ? item[heading] : '-')
              }
            })

            data.push(temp)
          })

          // Finally make csv and force download...
          const csv = '\ufeff' + Papa.unparse(data, { delimiter: ';' })
          const blob = new Blob([csv], {
            type: 'application/csvcharset=utf-8'
          })

          fileDownload(blob, 'objekter-' + moment().format('DDMMYYHms') + '.csv')
        })
        .catch((error) => {
          console.log('Error')
          console.log(error)
          this.$helpers.showErrorAlert('Feil', 'Kunne ikke generere CSV/Excel fil')
        })
        .then(() => {
          console.log('Done exporting')
          this.exporting = false
        })
    },
    // See: https://github.com/SortableJS/Vue.Draggable
    onDragChange: function (event) {
      if (event.moved) {
        let x = event.moved.oldIndex
        let y = event.moved.newIndex

        // Update array, move and shift down or up...
        if (x > y) {
          for (let i = x; i > y; --i) {
            this.selectedCols = swapArrayElements(this.selectedCols, i, i - 1)
          }
        } else {
          for (let i = x; i < y; ++i) {
            this.selectedCols = swapArrayElements(this.selectedCols, i, i + 1)
          }
        }
      }
    },
    onDragMove: function (event, originalEvent) {
      return true
      /*
      console.log('Move')
      console.log(event.draggedContext.element.value)
      console.log(event.relatedContext)
      // return true

      // Only return true if this is on
      return event.draggedContext.element.value
      */
    },
    toggleSettingsPopover: function () {
      this.settingsPopoverActive = !this.settingsPopoverActive
    },
    saveColumns: function () {
      // Send update event back to parent
      this.$emit('on_update_columns', this.selectedCols)

      this.settingsPopoverActive = false
    },
    resetColumns: function () {
      console.log('Reset back to default')
      console.log(this.selectedCols)

      // Reset cols to what they were before
      // this.selectedCols = this._.cloneDeep(this.settings.columns)

      // Reset cols to defaults + save
      this.selectedCols = []
      this.defaultColumns.forEach((item) => {
        this.selectedCols.push({ name: item.name, value: true })
      })
      this.saveColumns()
    },
    fetch: function () {
      this.loaded = 0

      this.catList = []
      this.avdDropdown.unshift({key: null, val: 'Laster...'})
      this.typeDropdown.unshift({key: null, val: 'Laster...'})

      InstillingerService('kategori').dropdown('kode')
        .then((response) => {
          this.catList = response.data
        })
        .catch(() => {
          // Skip error
          this.$helpers.showErrorAlert('Feil', 'Kunne ikke laste ned kategori innstillinger')
        })
        .then(() => {
          ++this.loaded
        })

      InstillingerService('avdeling').dropdown()
        .then((response) => {
          this.avdDropdown = response.data
          this.avdDropdown.unshift({ key: null, val: 'Alle' })
        })
        .catch(() => {
          // Skip error
          this.$helpers.showErrorAlert('Feil', 'Kunne ikke laste ned avdeling innstillinger')
        })
        .then(() => {
          ++this.loaded
        })

      InstillingerService('objekttype').dropdown()
        .then((response) => {
          this.typeDropdown = response.data
          this.typeDropdown.unshift({ key: null, val: 'Alle' })
        })
        .catch(() => {
          // Skip error
          this.$helpers.showErrorAlert('Feil', 'Kunne ikke laste ned objekttype innstillinger')
        })
        .then(() => {
          ++this.loaded
        })
    },
    onKunstnerSearchInput: function (query) {
      return KunstnerService.search(query)
    },
    onKunstnerSearchSelected: function (item) {
      if (item) {
        this.params.Kunstnername = item.Navn
        this.params.Kunstnerid = item.Idnr
      } else {
        this.params.Kunstnername = null
        this.params.Kunstnerid = null
      }
    },
    onKunstnerReset: function () {
      this.params.Kunstnername = null
      this.params.Kunstnerid = null
    },
    onAuksjonSearchInput: function (query) {
      return AuksjonService.search(query, this.params.Avdelingsid)
    },
    onAuksjonSearchSelected: function (item) {
      if (item) {
        this.params.Auksjon = item.Auksjon
      } else {
        this.params.Auksjon = null
      }
    },
    onAuksjonReset: function () {
      this.params.Auksjon = null
    },
    resetForm: function () {
      this.exporting = false
      bus.$emit('reset-advanced-form')
    },
    closeSearch: function () {
      this.exporting = false
      bus.$emit('close-advanced-form')
    },
    submitForm: function () {
      this.exporting = false
      bus.$emit('search-advanced-form')
    }
  }
}
</script>
<style scoped>
  #columnsorter ul {
    display: block;
  }
</style>



// WEBPACK FOOTER //
// src/components/Admin/TheMainSearchAdvancedForm.vue